import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import ProductNav from '../../common/ProductNav';
import { tabsValues } from '../../config/pageConfig';
import Banner from './components/Banner';
import FooterTcA from './components/FooterTcA';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import PageNavLeft, { Theme } from './components/PageNavLeft';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';
import ProductComparison from './components/ProductComparison';
import InstantProtection from './components/InstantProtection';
import BrownoutAnxiety from './components/BrownoutAnxiety';
import LongTermReliability from './components/LongTermReliability';
import QuietPower from './components/QuietPower';
import CompactDesign from './components/CompactDesign';

export default function StatusItem() {
    const [isClient, setIsClient] = useState(false);
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const { t } = useLang('Delta3AirSeries.PageNavLeft');
    const { query } = useRouter();
    const searchTab = query?.tab;
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <ProductNav activeTab={activeTab} />
            {activeTab === 'Product' && (
                <section className="ecoflow-d3a-air-page">
                    <Banner />
                    <PageNavLeft
                        triggerElement=".ecoflow-d3a-air-page"
                        enterElement="#List-sence-A"
                        steps={
                            [
                                { text: t('item1'), href: '#List-sence-A' },
                                { text: t('item2'), href: '#List-sence-B' },
                                { text: t('item3'), href: '#List-sence-C' },
                                { text: t('item4'), href: '#List-sence-D' },
                                { text: t('item5'), href: '#List-sence-E' },
                                { text: t('item6'), href: '#D3A-CompactDesign' },
                                { text: t('item7'), href: '#D3A-QuietPower' },
                                { text: t('item8'), href: '#D3A-LongTermReliability' },
                                { text: t('item9'), href: '#D3A-BrownoutAnxiety' },
                            ].filter(Boolean) as any
                        }
                    />
                    <B />
                    <C />
                    <D />
                    <E />
                    <F />
                    <G />
                    <H />
                    <CompactDesign />
                    <QuietPower />
                    <LongTermReliability />
                    <BrownoutAnxiety />
                    <InstantProtection />
                    <ProductComparison />
                    <FooterTcA />
                </section>
            )}
            {/* {activeTab === 'Bundles' && (
                <>
                    <Bundles addShopCartCallback={handleAddToCart} />
                </>
            )} */}
        </>
    );
}
